
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/glossary",
      function () {
        return require("private-next-pages/resources/glossary.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/glossary"])
      });
    }
  